import { cn } from "@/lib/utils"; // Assuming utils path
import {
  NavigationMenu,
  NavigationMenuList,
  NavigationMenuItem,
  navigationMenuTriggerStyle,
} from "@/components/ui/navigation-menu"; // Assuming UI components path
import { TreatmentsMenu, MoreMenu } from "./NavMenus"; // Import existing menu components

export const DesktopNav = () => {
  return (
    <NavigationMenu>
      <NavigationMenuList>
        {/* About Link */}
        <NavigationMenuItem>
          {/* Using anchor tag directly as NavigationMenuLink expects 'href' */}
          <a
            href="/about"
            className={cn(
              navigationMenuTriggerStyle(),
              "bg-transparent text-sm font-medium",
            )}
          >
            {" "}
            {/* Added base styles */}
            About
          </a>
        </NavigationMenuItem>

        {/* Treatments Dropdown */}
        <TreatmentsMenu />

        {/* More Dropdown */}
        <MoreMenu />
      </NavigationMenuList>
    </NavigationMenu>
  );
};
